import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { resultsTokens as t } from './tokens';

export function NameCell({ name, highlight }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
            <Typography sx={{
                fontSize: 14,
                color: t.color.fg,
                fontWeight: 550,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}>
                {name}
            </Typography>
            {highlight && (
                <Tooltip title="Alto potencial" arrow>
                    <Box component="span" sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        height: 18,
                        px: 0.75,
                        borderRadius: 999,
                        backgroundColor: t.color.starOk,
                        color: '#FFFFFF',
                        fontSize: 11,
                        fontWeight: 700,
                        lineHeight: 1,
                        letterSpacing: 0.3,
                    }}>
                        AP
                    </Box>
                </Tooltip>
            )}
        </Box>
    );
}

export function LevelChip({ value, title }) {
    if (!value) return null;
    const chip = (
        <Typography component="span" sx={{
            fontSize: 13,
            fontWeight: 700,
            color: t.color.fg,
        }}>
            {value}
        </Typography>
    );
    if (!title) return chip;
    return <Tooltip title={title} arrow>{chip}</Tooltip>;
}

const PERF_STYLE = {
    high: { dot: t.color.success, bg: t.color.successSoft, fg: '#065F46' },
    medium: { dot: t.color.warning, bg: t.color.warningSoft, fg: '#92400E' },
    low: { dot: t.color.danger, bg: t.color.dangerSoft, fg: '#9F1239' },
};

export function PerformancePill({ rawValue, label }) {
    const key = rawValue === 3 ? 'high' : rawValue === 2 ? 'medium' : rawValue === 1 ? 'low' : null;
    if (!key) {
        return <Typography sx={{ fontSize: 13, color: t.color.fgMuted }}>{label || '—'}</Typography>;
    }
    const s = PERF_STYLE[key];
    return (
        <Box sx={{
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'center',
            height: 22,
            px: 1,
            borderRadius: 999,
            backgroundColor: s.bg,
            color: s.fg,
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1,
        }}>
            {label}
        </Box>
    );
}
